const defaultHost = '192.168.8.1';
const defaultPort = 5053;

export default {
  defaultHost,
  defaultPort,
};
